/* eslint global-require: 0 */
const DeleteAssetModal = require('./common/DeleteAssetModal').default;

const apiType = { DeleteAssetModal };
const portalsDefinition = {
  'api-group': require('./api-group').default,
  'rest-api': apiType,
  'soap-api': apiType,
  'http-api': apiType,
  agent: apiType,
  'evented-api': apiType,
  graphql: apiType,
  llm: apiType,
  mcp: apiType
};

module.exports = portalsDefinition;
